import { actionCreatorFactoryForBootstrap } from "../../lib/bootstrap";
import { PostArticlesShowResponse } from "../api";

const bootstrapActionCreator = actionCreatorFactoryForBootstrap();

export const bootstrapPostArticlesShow = bootstrapActionCreator<PostArticlesShowResponse>("post_articles#show");
export const bootstrapEmployeeInterviewsShow = bootstrapActionCreator<PostArticlesShowResponse>(
  "employee_interviews#show"
);



// WEBPACK FOOTER //
// ./frontend/src/post_articles/actions/index.ts